import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface ClassificationBadgeProps {
  hasSportField: boolean | null;
  className?: string;
}

const COLORS = {
  positive: { backgroundColor: "#40C057", color: "white" },
  negative: { backgroundColor: "#FF646C", color: "white" },
  neutral: { backgroundColor: "#F59E0B", color: "white" },
} as const;

export function ClassificationBadge({
  hasSportField,
  className,
}: ClassificationBadgeProps) {
  if (hasSportField === true) {
    return (
      <Badge className={cn("border-transparent", className)} style={COLORS.positive}>
        Has sport field
      </Badge>
    );
  }

  if (hasSportField === false) {
    return (
      <Badge variant="secondary" className={cn("border-transparent", className)} style={COLORS.negative}>
        No Field
      </Badge>
    );
  }

  return (
    <Badge className={cn("border-transparent", className)} style={COLORS.neutral}>
      Unclassified
    </Badge>
  );
}
